import userActionRequest from './userActions.request';
import createService from '../Utils/createService';
import handleServiceError from '../Utils/handleServiceError';
import { ServiceTypes } from '../Constants/api.constants';
import {
    RETRY_COUNT_API_SERVICE_DEFAULT,
} from '../../Errors/Constants/Error.retries';

const createUserActionsService = (configStoreUpdate$, handleError) =>
    createService(
        ServiceTypes.USER_ACTIONS,
        configStoreUpdate$,
        userActionRequest,
        handleServiceError(ServiceTypes.USER_ACTIONS, handleError),
        RETRY_COUNT_API_SERVICE_DEFAULT,
    );

export default createUserActionsService;
